import {BASIC_INITIAL_STATE} from '@usas/ui-web/utils/HttpHelper';

import putOtherOrgOrgUnitChangeData from './PutOtherOrgOrgUnitChangeData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE, items: []
};

const OtherOrgOrgUnitChangeData = {
  INITIAL_STATE, putOtherOrgOrgUnitChangeData
};

export default OtherOrgOrgUnitChangeData;